module.exports = __webpack_public_path__ + "static/media/different-equation-bg-1.adc86905.webp";